import { Component, OnInit, Output, EventEmitter, Input  } from '@angular/core';
import * as XLSX from 'xlsx';
import * as Papa from 'papaparse';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

class Signatories {
  email_person: string = '';
  defined_signature_methods: string[] = [];
  name: string = '';
  tax_id: string = '';
}

@Component({
  selector: 'app-signature-bulk-modal',
  templateUrl: './signature-bulk-modal.component.html',
  styleUrls: ['./signature-bulk-modal.component.css']
})
export class SignatureBulkModalComponent implements OnInit {
  signatories: Signatories = new Signatories();
  constructor(public activeModal: NgbActiveModal) { }
  all_signatories

  ngOnInit(): void {
  }

  jsonData: any[] = [];

  @Output() close = new EventEmitter<void>();

  @Input() my_modal_title:string = "Firma de documentos";
  @Input() my_modal_content:string = "Lista de Firmantes";

  closeModal() {
    this.close.emit();
  }

  closeModalWithResult() {
    // Pass data back to the parent component
    this.activeModal.close(this.jsonData);
  }

  closeModalWithoutResult() {
    // Dismiss the modal without passing data
    this.activeModal.dismiss('Dismissed without result');
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handleFile(files[0]);
    }
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.handleFile(file);
    }
  }

  handleFile(file: File) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = e.target.result;
      if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
          file.type === 'application/vnd.ms-excel') {
        this.readExcelFile(data);
      } else if (file.type === 'text/csv') {
        this.readCSVFile(data);
      } else {
        console.error('Unsupported file type');
      }
    };
    reader.readAsBinaryString(file);
  }

  readExcelFile(data: string) {
    const workbook = XLSX.read(data, { type: 'binary' });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

    this.processData(jsonData);
  }

  readCSVFile(data: string) {
    Papa.parse(data, {
      complete: (result) => {
        this.processData(result.data);
      },
      header: false
    });
  }

  processData(data: any[]) {
    const extractedData = data.map(row => ({
      fullName: row[0],
      email: row[1],
      rfc: row[2]
    }));

    this.jsonData = extractedData;
  }

}
